exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".breadcrumbs-view-wrapper {\r\n  height: 70px;\r\n  /*border:1px solid blue;*/\r\n}\r\n\r\n.breadcrumb-text-area {\r\n  padding: 30px 0 30px 22px;\r\n  line-height: 10px;\r\n}\r\n\r\n.breadcrumb-item {\r\n  font-size: 13px;\r\n  color: #616365;\r\n  cursor: default;\r\n}\r\n\r\n.breadcrumb-item-hand-cursor {\r\n  cursor: pointer;\r\n}\r\n\r\n.breadcrumb-item-hand-cursor:hover {\r\n  font-weight: bold;\r\n  color: #0073AB;\r\n}\r\n/*\r\nbreadcrumb-item:active {\r\n  font-size: 13px;\r\n  color: #12408B\r\n}\r\n*/\r\n.breadcrumb-separator {\r\n  margin: 0 10px;\r\n  color: #616365;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/layout/home/breadcrumb/breadcrumb.component.css
// module id = ../../../../../src/app/layout/home/breadcrumb/breadcrumb.component.css
// module chunks = main